(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-team"] && !Shopify.designMode) return;
  try {
    

 $(document).ready(function(){

    var containerHeight = $('.team2').offset().top;

    $(window).scroll(function(){
       var scrollPosition = $(window).scrollTop();
        if (scrollPosition > (containerHeight - 200))
        {
            $('.about-left .image1').removeClass("show"); 
            $('.about-left .image2').addClass("show"); 
            $('.about-left .images-sticky').removeClass("remove-transform");

        }
          
        else if (scrollPosition < (containerHeight))
        {
            $('.about-left .image1').addClass("show"); 
            $('.about-left .image2').removeClass("show");
          $('.about-left .images-sticky').removeClass("remove-transform");
        }

      

    }) // scroll function


   

})// end document
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    


  var loadedClass = $('.fc-menu li').attr('class');
    $('.fc-menu li').eq(0).addClass('active'); 

  $('.fc-products .collection-container').each(function() {

        var crrnt = $(this);

        if (crrnt.hasClass(loadedClass)) {
            crrnt.addClass('show');
        }

        else {
            crrnt.removeClass('show');
        }
    });

  $('.fc-menu li').on('click', function() {


        if (!$(this).hasClass('active')) {
            var clickedClass = $(this).attr('class');
            $('.fc-menu li').removeClass('active');
            $(this).toggleClass('active');


            $('.fc-products .collection-container').each(function() {
                var crrnt = $(this);

                if (crrnt.hasClass(clickedClass)) {
                    crrnt.addClass('show');
                }

                else {
                    crrnt.removeClass('show');
                }
            });	
        }
    });

  


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gtl-room"] && !Shopify.designMode) return;
  try {
    
  
if ($('.get-the-look').length > 0) {

  if ($('.img-side').length > 0) {

    /* var loadedClass = $('.img-side ul li').attr('class');
    $('.img-side ul li').eq(0).addClass('active');    

    $('.ff-section .single-product').each(function() {

        var crrnt = $(this);

        if (crrnt.hasClass(loadedClass)) {
            crrnt.addClass('show');
        }

        else {
            crrnt.removeClass('show');
        }
    });	*/

    $('.img-side ul li').on('click', function() {


        if (!$(this).hasClass('active')) {
            var clickedClass = $(this).attr('class');
            $('.img-side ul li').removeClass('active');
            $(this).toggleClass('active');


            $('.ff-section .single-product').each(function() {
                var crrnt = $(this);

                if (crrnt.hasClass(clickedClass)) {
                    crrnt.addClass('show');
                }

                else {
                    crrnt.removeClass('show');
                }
            });	
        }
    });
  }
}

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-get-the-look"] && !Shopify.designMode) return;
  try {
    
  
if ($('.hp-get-the-look').length > 0) {

  if ($('.img-side').length > 0) {

     var loadedClass = $('.img-side ul li').attr('class');
    $('.img-side ul li').eq(0).addClass('active');    

    $('.hp-gtl .single-product').each(function() {

        var crrnt = $(this);

        if (crrnt.hasClass(loadedClass)) {
            crrnt.addClass('show');
        }

        else {
            crrnt.removeClass('show');
        }
    });	

    $('.img-side ul li').on('click', function() {


        if (!$(this).hasClass('active')) {
            var clickedClass = $(this).attr('class');
            $('.img-side ul li').removeClass('active');
            $(this).toggleClass('active');


            $('.hp-gtl .single-product').each(function() {
                var crrnt = $(this);

                if (crrnt.hasClass(clickedClass)) {
                    crrnt.addClass('show');
                }

                else {
                    crrnt.removeClass('show');
                }
            });	
        }
    });
  }
}

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-slideshow"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  $('.homepage-slideshow').slick({
    autoplay: true,
    autoplaySpeed: 3000,
    fade: true,
    pauseOnHover: false,
    arrows: false
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    

    $('.mobile.collection-nav .menu-open').on('click', function() {
    $('.mobile.collection-nav').toggleClass('expand');
  });

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    

$(window).on('load', function() {

  // duration of scroll animation
  var scrollDuration = 300;
  // paddles
  var leftPaddle = document.getElementsByClassName('left-paddle');
  var rightPaddle = document.getElementsByClassName('right-paddle');
  // get items dimensions
  var itemsLength = $('.item').length;
  var itemSize = $('.item').outerWidth(true);
  // get some relevant size for the paddle triggering point
  var paddleMargin = 20;
  
  // get wrapper width
  var getMenuWrapperSize = function() {
    return $('.menu-wrapper').outerWidth();
  }
  var menuWrapperSize = getMenuWrapperSize();
  // the wrapper is responsive
  $(window).on('resize', function() {
    menuWrapperSize = getMenuWrapperSize();
  });
  // size of the visible part of the menu is equal as the wrapper size 
  var menuVisibleSize = menuWrapperSize;
  
  // get total width of all menu items
  var getMenuSize = function() {
    return itemsLength * itemSize;
  };
  var menuSize = getMenuSize();
  // get how much of menu is invisible
  var menuInvisibleSize = menuSize - menuWrapperSize;
  
  // get how much have we scrolled to the left
  var getMenuPosition = function() {
    return $('.menu').scrollLeft();
  };
  
  // finally, what happens when we are actually scrolling the menu
  $('.menu').on('scroll', function() {
  
    // get how much of menu is invisible
    menuInvisibleSize = menuSize - menuWrapperSize;
    // get how much have we scrolled so far
    var menuPosition = getMenuPosition();
  
    var menuEndOffset = menuInvisibleSize - paddleMargin;
  
    // // show & hide the paddles 
    // // depending on scroll position
   if (menuPosition <= paddleMargin) {
   // $(leftPaddle).addClass('hidden');
   $(rightPaddle).removeClass('hidden');
    } else if (menuPosition < menuEndOffset) {
    //   // show both paddles in the middle
     $(leftPaddle).removeClass('hidden');
    $(rightPaddle).removeClass('hidden');
     } else if (menuPosition >= menuEndOffset) {
    $(leftPaddle).removeClass('hidden');
  //  $(rightPaddle).addClass('hidden');
    }
  
    // print important values
    $('#print-wrapper-size span').text(menuWrapperSize);
    $('#print-menu-size span').text(menuSize);
    $('#print-menu-invisible-size span').text(menuInvisibleSize);
    $('#print-menu-position span').text(menuPosition);
  
  });
  
  // scroll to left
  $(rightPaddle).on('click', function() {
    $('.menu').animate({
      scrollLeft: getMenuPosition() + ($('.menu').width()/2)
    }, scrollDuration);
  });
  
  // scroll to right
  $(leftPaddle).on('click', function() {
  
    $('.menu').animate({
      scrollLeft: getMenuPosition() - ($('.menu').width()/2)
    }, scrollDuration);
  });

  });

  
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-masonry"] && !Shopify.designMode) return;
  try {
    

  $(window).ready(function() {
     var $grid = $('.project-masonry');


  $grid.masonry({
    itemSelector: '.article-block',
  columnWidth: '.article-block',
  percentPosition: true,
  gutter: '.gutter-sizer'
  });
});

 



  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbr-grid"] && !Shopify.designMode) return;
  try {
    

    $('.mobile.sbr-nav .menu-open').on('click', function() {
    $('.mobile.sbr-nav').toggleClass('expand');
  });

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-image"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function(){

    var containerHeight = $('.team-image').offset().top;

    $(window).scroll(function(){
       var scrollPosition = $(window).scrollTop();
        if (scrollPosition > (containerHeight * .8))
        {
            $('.team-image img').addClass("is-visible");   
        }
    }) 

})
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-section"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function(){

    var containerHeight = $('.team-sticky-scroll').height();
    $('.team-section img').eq(0).addClass('show');

    $(window).scroll(function(){
       var scrollPosition = $(window).scrollTop();
        if (scrollPosition > (containerHeight))
        {
          if (scrollPosition < (containerHeight * 2)) {
            $('.team-section img').eq(1).removeClass("show"); 
            $('.team-section img').eq(0).addClass("show"); 
          }

          else if (scrollPosition > (containerHeight * 2))
        {
             $('.team-section img').eq(0).removeClass("show");
             $('.team-section img').eq(1).addClass("show");
        }
        }
          
        

    }) // scroll function

})// end document
  

  } catch(e) { console.error(e); }
})();
})();
